import { Link, useParams } from "react-router-dom";
import { H5SubPageShell } from "../components/common/H5SubPageShell";
import {
  H5_LEGAL_DOCS,
  H5_LEGAL_NAV_SLUGS,
  H5_LEGAL_TITLES,
  isH5LegalSlug,
} from "./h5LegalContent";
import "./LegalDocPage.css";

/** H5 法规文档页：用户协议 / 隐私政策 / 法律合规 */
export default function LegalDocPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const known = isH5LegalSlug(slug);
  const title = known ? H5_LEGAL_TITLES[slug] : "文档";
  const doc = known ? H5_LEGAL_DOCS[slug] : null;

  return (
    <H5SubPageShell title={title}>
      <div className="legal-doc-page">
        {doc ? (
          <article className="legal-doc-page__article">
            <p className="legal-doc-page__updated">更新日期：{doc.updatedAt}</p>
            {doc.preamble?.map((paragraph) => (
              <p key={paragraph} className="legal-doc-page__p">
                {paragraph}
              </p>
            ))}
            {doc.sections.map((section) => (
              <section key={section.heading} className="legal-doc-page__section">
                <h2 className="legal-doc-page__h2">{section.heading}</h2>
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph} className="legal-doc-page__p">
                    {paragraph}
                  </p>
                ))}
              </section>
            ))}
            <nav className="legal-doc-page__nav" aria-label="相关文档">
              {H5_LEGAL_NAV_SLUGS.map((navSlug) => (
                <Link
                  key={navSlug}
                  className={
                    navSlug === slug
                      ? "legal-doc-page__nav-link legal-doc-page__nav-link--current"
                      : "legal-doc-page__nav-link"
                  }
                  to={`/legal/${navSlug}`}
                >
                  {H5_LEGAL_TITLES[navSlug]}
                </Link>
              ))}
            </nav>
          </article>
        ) : (
          <p className="legal-doc-page__empty">文档不存在。</p>
        )}
      </div>
    </H5SubPageShell>
  );
}
